import { College } from '@backrs_ui/common-ui';

import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithAuth } from '../baseQuery';
import { selectIsSharedSessionActive } from '../sharedSession/sharedSession';
import type { RootState } from '../store';

export const collegeApi = createApi({
  reducerPath: 'collegeApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (build) => ({
    getCollegeById: build.query<College, string>({
      queryFn: async (id, queryApi, _extraOptions, baseQuery): Promise<{ data: College }> => {
        const state = queryApi.getState() as RootState;
        const isSharedSession: boolean = selectIsSharedSessionActive(state);

        const url: string = isSharedSession
          ? `shared/solution-session/colleges/${id}`
          : `colleges/${id}`;

        return baseQuery({ url }) as Promise<{ data: College }>;
      },
      keepUnusedDataFor: 60 * 60 * 24,
    }),
    getCollegeByName: build.query<College, string>({
      query: (name) => `colleges/name/${name}`,
      keepUnusedDataFor: 60 * 60 * 24,
    }),
    getCollegeByInstitutionId: build.query<College, string>({
      queryFn: async (id, queryApi, _extraOptions, baseQuery): Promise<{ data: College }> => {
        const state = queryApi.getState() as RootState;
        const isSharedSession: boolean = selectIsSharedSessionActive(state);

        const url: string = isSharedSession
          ? `shared/solution-session/colleges/institution/${id}`
          : `colleges/institution/${id}`;

        return baseQuery({ url }) as Promise<{ data: College }>;
      },
      keepUnusedDataFor: 60 * 60 * 24,
    }),
  }),
});

export const {
  useGetCollegeByIdQuery,
  useGetCollegeByNameQuery,
  useGetCollegeByInstitutionIdQuery,
  usePrefetch: usePrefetchCollege,
  util: { resetApiState },
} = collegeApi;
